// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiLoginRequest {
    'is_safe_wallet': boolean;
    'client_address': string;
    'client_signature': string;
    'server_signature': string;
    'role'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "is_safe_wallet",
            "baseName": "is_safe_wallet",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "client_address",
            "baseName": "client_address",
            "type": "string",
            "format": ""
        },
        {
            "name": "client_signature",
            "baseName": "client_signature",
            "type": "string",
            "format": ""
        },
        {
            "name": "server_signature",
            "baseName": "server_signature",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiLoginRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

